import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { StatusBadge, fmtDate } from "@/components/badges";
import { RichTextView } from "@/components/RichTextEditor";
import { ActivityTimeline } from "@/components/ActivityTimeline";
import { useTranslation } from "react-i18next";

export function ViewRequestDialog({ req, onClose }) {
  const { t } = useTranslation();

  return (
    <Dialog open={!!req} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="view-request-dialog">
        <DialogHeader><DialogTitle>{req?.title}</DialogTitle></DialogHeader>
        <div className="space-y-4 text-sm">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-slate-500">
            <Badge variant="outline" className="font-mono text-xs">{req?.category}</Badge>
            <span>
              <span className="font-medium text-slate-700">{req?.requester?.company_name}</span>
              <span className="mx-1 text-slate-400">→</span>
              <span className="font-medium text-slate-700">{req?.target?.company_name}</span>
            </span>
            <span className="font-mono">{t("dashboard.due")}: {fmtDate(req?.due_date)}</span>
            <StatusBadge status={req?.status} data-testid="view-request-status" />
          </div>
          {req?.description && (
            <div data-testid="view-request-description">
              <div className="font-mono text-xs uppercase tracking-wider text-slate-500">{t("common.description")}</div>
              <RichTextView html={req.description} className="mt-1 text-slate-800" />
            </div>
          )}
          <ActivityTimeline
            testId="request-history"
            title={t("common.history")}
            events={req ? [
              { kind: "created", label: t("common.evCreated"), by: req.created_by_email, at: req.created_at },
              ...(req.updated_at ? [{ kind: "edited", label: t("common.evEdited"), by: req.updated_by, at: req.updated_at }] : []),
              ...(req.fulfilled_at ? [{ kind: "fulfilled", label: t("common.evFulfilled"), by: req.fulfilled_by_email, at: req.fulfilled_at }] : []),
              ...(req.cancelled_at ? [{ kind: "cancelled", label: t("common.evCancelled"), by: req.cancelled_by, at: req.cancelled_at, detail: req.cancel_reason }] : []),
            ] : []}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
